var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66666H6.66667",
    stroke: "#697586",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 7.33334H12.1538C10.9643 7.33334 10 8.22877 10 9.33334C10 10.4379 10.9643 11.3333 12.1538 11.3333H13.8889C13.9444 11.3333 13.9722 11.3333 13.9957 11.3319C14.3552 11.31 14.6416 11.0441 14.6651 10.7103C14.6667 10.6885 14.6667 10.6627 14.6667 10.6111V8.05557C14.6667 8.00398 14.6667 7.97819 14.6651 7.95641C14.6416 7.62257 14.3552 7.35665 13.9957 7.33477C13.9722 7.33334 13.9444 7.33334 13.8889 7.33334Z",
    stroke: "#697586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 7.33333C13.9248 6.08513 13.7577 5.31983 13.2189 4.78105C12.4378 4 11.1807 4 8.66658 4H6.66658C4.15243 4 2.89535 4 2.1143 4.78105C1.33325 5.5621 1.33325 6.81918 1.33325 9.33333C1.33325 11.8475 1.33325 13.1046 2.1143 13.8856C2.89535 14.6667 4.15243 14.6667 6.66658 14.6667H8.66658C11.1807 14.6667 12.4378 14.6667 13.2189 13.8856C13.7577 13.3468 13.9248 12.5815 13.9766 11.3333",
    stroke: "#697586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L6.49032 2.34876C7.19162 1.88375 8.14171 1.88375 8.84301 2.34876L11.3333 4",
    stroke: "#697586",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9942 9.33334H12.0002",
    stroke: "#697586",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon1);
export default __webpack_public_path__ + "static/media/WalletIcon1.ba559b3c706994f1462a0f2939288960.svg";
export { ForwardRef as ReactComponent };